import { GrLinkedin } from "react-icons/gr";
import { SiLeetcode } from "react-icons/si";
import { IoDocumentAttachSharp } from "react-icons/io5";
import { SiGmail } from "react-icons/si";
import { BsGithub } from "react-icons/bs";
import { SiCodechef } from "react-icons/si";
import { FaCode } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { SiGeeksforgeeks } from "react-icons/si";

export const headerLinks = [
    {
        name: "LinkedIn",
        icon: <GrLinkedin size={21} />,
        color: "dodgerblue",
        url: "https://www.linkedin.com/in/arghya-deep-pal7/",
    },
    {
        name: "LeetCode",
        icon: <SiLeetcode size={21} />,
        color: "orange",
        url: "https://www.leetcode.com/arghyadeep7/",
    },
    {
        name: "Github",
        icon: <BsGithub size={21} />,
        url: "https://www.github.com/Arghyadeep7/",
        color: "black",
    },
    {
        name: "GeeksForGeeks",
        icon: <SiGeeksforgeeks size={25} />,
        color: "chartreuse",
        url: "https://auth.geeksforgeeks.org/user/arghyadeep100/",
    },
    {
        name: "Gmail",
        icon: <SiGmail size={21} />,
        color: "red",
        url: "mailto:arghyadeep100@gmail.com",
    },
    {
        name: "Twitter",
        icon: <FaSquareXTwitter size={21} />,
        color: "grey",
        url: "https://www.twitter.com/Arghya_deep7/",
    },
];

export const about = `Arghya Deep is currently employed as a Software Engineer at Tata Consultancy Services since August 2024.

He is a Computer Science & Engineering graduate from Heritage Institute of Technology passed out in 2024 with a stellar CGPA of 9.21.

Prior to joining Tata Consultancy Services, he has interned at the following firms:
->	Software Engineer (SWE) Intern @Bentley Systems
->	Full Stack Developer (SDE) Intern @Pro GenX
He thereby comes with the full experience of hustling and developing in both settled and thriving developmental worlds.

With a very strong grasp on Data Structures & Algorithms having solved over 1500+ problems across all platforms and being very strong at problem-solving as well as managing/handling databases with ease, he is a worthy candidate for solving complex problems.

Apart from this he is a team player and a leader whenever and wherever it is required. He is a very determined, hard-working person who is always eager to learn new technologies and excel in them and is always on the lookout to find innovative and easy solutions to the hardest of problems!

He would welcome an interview or trial to share his expertise and skills and his thirst for development and excelling.
`;

export const pages = [
    "About",
    "Education",
    "Experience",
    "Projects",
    "Skills",
    "Certificates",
    "Profiles",
];

export const info = [
    {
        type: "text",
        label: "Name",
        value: "Arghya Deep Pal",
    },
    {
        type: "text",
        label: "Email",
        value: "arghyadeep100@gmail.com",
    },
    {
        type: "text",
        label: "Current Firm",
        value: "Tata Consultancy Services",
    },
    {
        type: "text",
        label: "Current Position",
        value: "Software Engineer",
    },
    {
        type: "text",
        label: "Current Location",
        value: "Kolkata, India",
    },
    {
        type: "text",
        label: "Status",
        value: "Hustling",
    },
];

export const education = [
    {
        institute: "Heritage Institute of Technology",
        url: "https://heritageit.edu",
        course: "Bachelor of Technology (B. Tech.)",
        specialisation: "Computer Science and Engineering (CSE)",
        grade: "9.21",
        from: 2020,
        to: 2024,
        achievement: null,
        link: null,
    },
    {
        institute: "B. D. Memorial International",
        url: "https://www.bdmi.org",
        course: "Class XII (AISSCE)",
        specialisation: "Computer Science",
        grade: "97.8%",
        from: 2019,
        to: 2020,
        achievement: "(School Topper)",
        link: "E-Certificates",
    },
    {
        institute: "B. D. Memorial International",
        url: "https://www.bdmi.org",
        course: "Class X (AISSE)",
        specialisation: "General Studies",
        grade: "96.6%",
        from: 2017,
        to: 2018,
        achievement: null,
        link: null,
    },
];

export const experience = [
    {
        firm: "TATA CONSULTANCY SERVICES",
        url: "https://www.tcs.com",
        position: "SOFTWARE ENGINEER",
        from: "Aug 2024",
        to: "Present",
        tech: [
            "Python",
            "Node.js",
            "PostgreSQL",
            "Splunk",
            "OpenShift",
            "React.js",
            "Material UI",
            "Flask",
        ],
        about: [
            "Developed scalable, Cloud-native microservices using Node.js & Fastify framework, migrating 100+ applications.",
            "Implemented OAuth, JWT. Enabled cookie & session storage so that user stays logged in for stipulated time frame.",
            "Setup PostgreSQL database through effective schema design, metadata management, and query optimization.",
            "Automated end-to-end deployment in OpenShift integrated with GitHub Actions for CI/CD workflows.",
            "Established comprehensive logging, monitoring, request tracing, and debugging capabilities using Splunk.",
            "Implemented Role-Based Access Control (RBAC) enabling only authorized users to manage job and batch-processing operations across modules while restricting unrelated permissions & reducing unnecessary database access.",
            "Designed & developed front-end using React.js, Redux & Bootstrap ensuring responsiveness with smooth UI/UX.",
            "Led a team in building a full-stack data analysis & profiling platform using Python & Flask delivering actionable insight into Data Quality, Distributions, Schema structures, & Anomalies across cloud databases, Excel, & CSV files.",
            "Optimized complex query supporting multi-table joins, metadata analysis, large-scale data exploration with improved efficiency & mitigating SQL injection risks while enabling flexible dynamic query generation."
        ],
    },
    {
        firm: "BENTLEY SYSTEMS",
        url: "https://www.bentley.com",
        position: "SOFTWARE ENGINEER INTERN (SWE) [6 Months]",
        from: "Feb 2024",
        to: "Jul 2024",
        tech: ["C#", "ASP.NET", "C++", "Python", "SQL", "Git"],
        about: [
            "Enhanced ItemType features in MicroStation, implementing Attach, Edit, and Clone workflows using C# & ASP.NET.",
            "Implemented Key-ins as Palette Commands, enabling users to execute specific MicroStation operations.",
            "Implemented robust error-handling and retry mechanisms, improving application resilience and ensuring fail-safe.",
            "Debugged, optimized, and implemented PBIs for ItemType Attach, Edit, & Clone workflows.",
            "Developed Unit, Integration & System Tests improving functional coverage and software reliability.",
        ],
    },
    // {
    //     firm: "VComply",
    //     url: "https://www.v-comply.com",
    //     position: "Software Engineer Intern",
    //     from: "Jan 2024",
    //     to: "Feb 2024",
    //     about: [
    //         "Started working on an internal employee dashboard project for leave management of employees",
    //     ],
    //     tech: ["React.js", "Node.js", "Express.js", "MongoDB", "Bootstrap"],
    // },
    {
        firm: "PRO GENX",
        url: "https://progx.in",
        position: "FULL STACK DEVELOPER INTERN (SDE) [3 Months]",
        from: "Jun 2023",
        to: "Aug 2023",
        tech: [
            "React.js",
            "Node.js",
            "Express.js",
            "MongoDB",
            "React-Bootstrap",
            "React-Apex Charts",
        ],
        about: [
            "Developed a versatile application tailored to meet the multifaceted needs of modern businesses.",
            "Developed code involving features such as Finance monitoring, events management, sales tracking, crypto etc.",
            "Used React.js for the front end along with Bootstrap and React-Apex charts for designing the UI and the front end.",
            "Used Node.js, Express.js for handling the back end and Passport auth to manage the authorization.",
        ],
    },
];

export const projects = [
    {
        name: "AURA-Abstraction Layer",
        repo: "",
        deployed: "",
        about: [
            "Match against fellow programmers & developers for collaborating on Hackathons, Open Source, Startups & Personal Projects",
            "Works just like Tinder, the only difference being it is purely for Developmental purposes",
            "Main users are college students who want to participate in Hackathons which requires a team",
            "Recommendation System implemented to suggest best fits",
            "Chatting feature available post mutual connection",
        ],
        tech: [
            "React.js",
            "Node.js",
            "Fastify",
            "Bootstrap",
            "PostgreSQL",
            "Splunk", 
            "OpenShift", 
            "Git",
            "GitHub"
        ],
    },
    {
        name: "Data Scout Profiler",
        repo: "",
        deployed: "",
        about: [
            "Profiling tool for generating insights on data qualities, distributions, structure anomalies, & trend recognition.",
            "Analyses complex data sets providing trends & patterns of data structures and anomalies with chart representation."
        ],
        tech: [
            "Python",
            "Flask",
            "React.js",
            "Bootstrap",
            "Git",
            "GitHub"
        ],
    },
    {
        name: "tinDEV",
        repo: "https://github.com/Arghyadeep7/tinDEV/",
        deployed: "",
        about: [
            "Website for developers to collaborate on Hackathons, OpenSource Projects, Startups & Personal projects.",
            "Mutual match-based system implemented. Strictly professional with no breach of privacy.",
            "Developed real-time messaging using Socket.io. Enabled investors on-boarding & funding processes."
        ],
        tech: [
            "React.js",
            "Node.js",
            "Express.js",
            "Bootstrap",
            "MongoDB",
            "Socket.io",
            "Git",
            "Vercel"
        ],
    },
    {
        name: "E-HUB",
        repo: "https://github.com/Arghyadeep7/E-Hub",
        deployed: "https://e-hub.vercel.app/",
        about: [
            "Website that provides every detail for all movies, tv/web-series, dramas etc. fetched dynamically from IMDB.",
            "Refreshes automatically with the latest movies, shows based on various filters with no database dependency."
        ],
        tech: [
            "React.js",
            "React-Bootstrap",
            "Node.js",
            "Express.js",
            "MongoDB",
            "CSS",
        ],
    },
    {
        name: "Mail-IT",
        repo: "https://github.com/Arghyadeep7/mail-it/",
        deployed: "https://mail-it.vercel.app/",
        about: [
            "Register and login to use the mailing app",
            "Compose and send emails to users across this platform",
            "Delete/star mails as necessary",
            "Updations occur in real-time",
            "Deep copy of mail(sender & receiver have different copies) implemented",
        ],
        tech: [
            "React.js",
            "React-Bootstrap",
            "Node.js",
            "Express.js",
            "MongoDB",
            "CSS",
        ],
    },
    {
        name: "Portfolio",
        repo: "https://github.com/Arghyadeep7/Resume/",
        deployed: "https://arghya-deep-pal.vercel.app/",
        about: [
            "CV | Resume Available",
            "Education",
            "Experience",
            "Projects",
            "Skills",
            "Certificates",
            "Profiles",
        ],
        tech: ["React.js", "React-Bootstrap"],
    },
];

export const skills = [
    {
        label: "Programming",
        tech: ["C++", "C#", "C", "Python", "Java", "Javascript"],
    },
    {
        label: "Front-End",
        tech: [
            "React.js",
            "Next.js",
            "Redux",
            "Bootstrap",
            "Material UI",
            "HTML",
            "CSS",
        ],
    },
    {
        label: "Back-End",
        tech: ["Node.js", "Express.js", "Flask"],
    },
    {
        label: "Database",
        tech: ["SQL", "noSQL", "MongoDB"],
    },
    {
        label: "Version Control",
        tech: ["Git", "GitHub"],
    },
    {
        label: "Deployment",
        tech: ["Vercel", "OpenShift", "GitHub-Actions"],
    },
];

export const certificates = [
    {
        label: "Process Data from Dirty to Clean",
        url: "https://www.coursera.org/account/accomplishments/certificate/6CG24UFARVSW",
        credential: "6CG24UFARVSW",
        org: "Google",
        date: "15 February 2023",
    },
    {
        label: "Prepare Data for Exploration",
        url: "https://www.coursera.org/account/accomplishments/certificate/AJRCZKGUPTY8",
        credential: "AJRCZKGUPTY8",
        org: "Google",
        date: "5 November 2022",
    },
    {
        label: "Python for Data Science, AI & Development",
        url: "https://www.coursera.org/account/accomplishments/certificate/KVXQSQX8PHF7",
        credential: "KVXQSQX8PHF7",
        org: "IBM",
        date: "13 October 2022",
    },
    {
        label: "Ask Questions to make Data-Driven Decisions",
        url: "https://www.coursera.org/account/accomplishments/certificate/6JSZ4EUE4D5X",
        credential: "6JSZ4EUE4D5X",
        org: "Google",
        date: "19 July 2022",
    },
    {
        label: "Foundations: Data, Data, Everywhere",
        url: "https://www.coursera.org/account/accomplishments/certificate/WF6989UWSRXV",
        credential: "WF6989UWSRXV",
        org: "Google",
        date: "27 June 2022",
    },
    {
        label: "Data Science Methodology",
        url: "https://www.coursera.org/account/accomplishments/certificate/M7XKHCZ345W2",
        credential: "M7XKHCZ345W2",
        org: "IBM",
        date: "13 June 2022",
    },
    {
        label: "Tools for Data Science",
        url: "https://www.coursera.org/account/accomplishments/certificate/8YBE75WQJS5Z",
        credential: "8YBE75WQJS5Z",
        org: "IBM",
        date: "2 June 2022",
    },
    {
        label: "What is Data Science?",
        url: "https://www.coursera.org/account/accomplishments/certificate/95B9947SM8V3",
        credential: "95B9947SM8V3",
        org: "IBM",
        date: "24 May 2022",
    },
    {
        label: "Full-Stack Web Development with React (Specialization)",
        url: "https://www.coursera.org/account/accomplishments/specialization/certificate/QZHU3SGKZE4P",
        credential: "QZHU3SGKZE4P",
        org: "Coursera",
        date: "17 May 2022",
    },
    {
        label: "Server-side Development with Node.js, Express.js & MongoDb",
        url: "https://www.coursera.org/account/accomplishments/certificate/PWJJ7W4W6BEV",
        credential: "PWJJ7W4W6BEV",
        org: "Coursera",
        date: "17 May 2022",
    },
    {
        label: "Front-end Web Development with React.js",
        url: "https://www.coursera.org/account/accomplishments/certificate/7B4PJZGCEQJX",
        credential: "7B4PJZGCEQJX",
        org: "Coursera",
        date: "18 March 2022",
    },
    {
        label: "React - The Complete Guide",
        url: "https://udemy-certificate.s3.amazonaws.com/pdf/UC-311503e7-2abb-4bd3-b67d-9f4189ddf3d3.pdf",
        credential: "UC-311503e7-2abb-4bd3-b67d-9f4189ddf3d3",
        org: "Udemy",
        date: "27 February 2022",
    },
    {
        label: "The Complete Web Development Bootcamp",
        url: "https://udemy-certificate.s3.amazonaws.com/pdf/UC-3e652598-678d-4e96-b24e-bc56547afe97.pdf",
        credential: "UC-3e652598-678d-4e96-b24e-bc56547afe97",
        org: "Udemy",
        date: "11 January 2022",
    },
    {
        label: "Front-End Web UI Frameworks and Tools : Bootstrap 4",
        url: "https://www.coursera.org/account/accomplishments/certificate/C24KMVPFLVPB",
        credential: "C24KMVPFLVPB",
        org: "Coursera",
        date: "23 August 2021",
    },
    {
        label: "HTML, CSS and Javascript for Web Developers",
        url: "https://www.coursera.org/account/accomplishments/certificate/VM2EZNJVATPJ",
        credential: "VM2EZNJVATPJ",
        org: "Coursera",
        date: "20 July 2021",
    },
    {
        label: "Crash Course on Python",
        url: "https://www.coursera.org/account/accomplishments/certificate/J427MF47RQZS",
        credential: "J427MF47RQZS",
        org: "Google",
        date: "12 June 2021",
    },
];

export const profiles = [
    {
        name: "LinkedIn",
        icon: <GrLinkedin size={20} />,
        color: "dodgerblue",
        url: "https://www.linkedin.com/in/arghya-deep-pal7/",
    },
    {
        name: "Portfolio",
        icon: <FaCode size={20} />,
        url: "https://adp7.vercel.app/",
        color: "purple",
    },
    {
        name: "LeetCode",
        icon: <SiLeetcode size={20} />,
        color: "orange",
        url: "https://www.leetcode.com/arghyadeep7/",
    },
    {
        name: "Resume",
        icon: <IoDocumentAttachSharp size={20} />,
        url: "https://adp7.vercel.app/assets/Arghya_Deep_Pal.pdf/",
        color: "lightseagreen",
    },
    {
        name: "GFG",
        icon: <SiGeeksforgeeks size={20} />,
        color: "green",
        url: "https://auth.geeksforgeeks.org/user/arghyadeep100/",
    },
    {
        name: "Github",
        icon: <BsGithub size={20} />,
        url: "https://www.github.com/Arghyadeep7/",
        color: "black",
    },
    {
        name: "CodeChef",
        icon: <SiCodechef size={20} />,
        color: "brown",
        url: "https://www.codechef.com/users/arghya7/",
    },
    {
        name: "Gmail",
        icon: <SiGmail size={20} />,
        color: "red",
        url: "mailto:arghyadeep100@gmail.com",
    },
    {
        name: "Twitter",
        icon: <FaSquareXTwitter size={20} />,
        color: "#333834",
        url: "https://www.twitter.com/Arghya_deep7/",
    },
];
